import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import Datetime from "react-datetime";
import moment from "moment";
import "moment-timezone";

import {styles} from "assets/jss/datetime-wrapper.jsx";

import general from "../general";

class DatetimeWrapper extends React.Component {

  render() {
    const {classes} = this.props;

    return <Datetime
      inputProps={this.props.inputProps}
      className={classes.datetime}
      onChange={(value) => {
        if (value === '')
          return this.props.onChange(null);
        if (value.format) {
          let time = moment.tz(value.format(((this.props.dateFormat ? "YYYY-MM-DD" : '') + " " + (this.props.timeFormat ? "HH:mm" : '')).trim()), general.guessTimezone().tz).toISOString();
          this.props.onChange(time);
        }
      }}
      dateFormat={this.props.dateFormat}
      timeFormat={this.props.timeFormat}
      utc={true}
      defaultValue={this.props.defaultValue ? moment(this.props.defaultValue).format(((this.props.dateFormat || '') + " " + (this.props.timeFormat || '')).trim()) : ""}
      isValidDate={this.props.valid}
    />;
  }
}

export default withStyles(styles)(DatetimeWrapper);
